import Slider from './js/template-parts/sections/slider.js'

window.addEventListener('load', function (event) {
  window.slider = new Slider()
})
